import type { Meta, StoryObj } from "@storybook/react";

import { InputLabel } from "@/ui/core";
import type { InputLabelProps } from "@/ui/core";
import { Box } from "@/ui/layout";

const StoryMeta: Meta<InputLabelProps> = {
  title: "Core/Input Label",
  component: InputLabel,
  argTypes: {
    secondaryText: { control: "text" },
    testID: { control: "text" },
    text: { control: "text" },
  },
  args: {
    secondaryText: "optional",
    testID: "input-label-test-id",
    text: "Input Label",
  },
  render: (props) => (
    <Box width={props.secondaryText ? "100%" : "auto"}>
      <InputLabel {...props} />
    </Box>
  ),
};

type Story = StoryObj<InputLabelProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
